import { __decorate } from "tslib";
import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http';
import { WORKSPACE_SERVICE_URI } from '@cores/constants/envConfig';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
let UserApiImpl = class UserApiImpl extends PsHttpService {
    get options() {
        return {
            baseURL: WORKSPACE_SERVICE_URI,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }
    async getUserInitApi() {
        const res = await this.get({
            url: '/workspace/web/permission/user',
            transformCode: true,
        });
        return res.data;
    }
    async getUserDataCountApi() {
        const res = await this.get({
            url: '/workspace/web/data/capacity',
            transformCode: true,
        });
        return res.data;
    }
};
UserApiImpl = __decorate([
    injectable()
], UserApiImpl);
export { UserApiImpl };
